import { Box, Grid, TextField, InputLabel, Button } from '@mui/material';
import PhoneInTalk from '@mui/icons-material/PhoneInTalk';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import InstagramIcon from '@mui/icons-material/Instagram';
import YouTubeIcon from '@mui/icons-material/YouTube';
import TwitterIcon from '@mui/icons-material/Twitter';
import FacebookIcon from '@mui/icons-material/Facebook';

export default function Footer() {
    const mainColor = '#FF4D30'
    return (
        <>
            <Box sx={{ backgroundColor: "#303030", color: 'white', pt: 1, pb: 3 }}>
                <Grid container direction="row" sx={{ m: 2, maxWidth: '90%' }} spacing={2} columnSpacing={4}>
                    <Grid item xs={12} sm={6} md={3}>
                        <h1>Rental Car</h1>
                        <div class="line" />
                        <p className="light">We offers a big range of vehicles for all your driving needs. Contact now to save big on your next rental.</p>
                        <div id="hover">
                            <PhoneInTalk sx={{ pr: 1 }} /> 1-800-Car-Rental</div>
                        <div id="hover" style={{ marginTop: 10 }}>
                            <MailOutlineIcon sx={{ pr: 1 }} />info@rentalcar.com</div>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <h1>Company</h1>
                        <div class="line" /> <br />
                        <a className="light">Seattle</a> <br />
                        <a className="light">Austin</a> <br />
                        <a className="light">New York</a> <br />
                        <a className="light">Los Angeles</a> <br />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <h1>Hours</h1>
                        <div class="line" />
                        <p className="light">Mon - Fri: 8:00AM - 10:00PM</p>
                        <p className="light">Sat: 9:00AM - 9:00PM</p>
                        <p className="light">Sun: Closed</p>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <h1>Newsletter</h1>
                        <div class="line" />
                        <TextField
                            variant="standard"
                            size="large"
                            margin="normal"
                            placeholder="Email"
                            fullWidth
                            color="secondary"
                            InputProps={{
                                style: {
                                    paddingLeft: 10,
                                    paddingTop: 5,
                                    paddingBottom: 5
                                }
                            }}
                            sx={{ color: 'grey', backgroundColor: 'white', borderRadius: '5 !important', border: 'none', "& fieldset": { border: 'none !important' } }} />


                        <Button fullWidth contained className={"button"} sx={{ borderRadius: 0, mt: 2 }}>
                            Subscribe
                        </Button>
                    </Grid>
                </Grid>
            </Box>
            <Box sx={{ backgroundColor: "#505050", color: 'white', p: 3, textAlign: "center", justifyContent: 'center', alignItems: 'center' }}>
                <h3 className="light"> Contact us now - We are social 24/7</h3>
                <InstagramIcon fontSize={'large'} sx={{ pr: 1, cursor: 'pointer', '& :hover': 'red !important' }} />
                <YouTubeIcon fontSize={'large'} sx={{ pr: 1, cursor: 'pointer' }} />
                <TwitterIcon fontSize={'large'} sx={{ pr: 1, cursor: 'pointer' }} />
                <FacebookIcon fontSize={'large'} sx={{ cursor: 'pointer' }} />
            </Box>
        </>
    )
}
